import type { Theme } from "@mui/material/styles";

/** Scrollbar do diálogo de questionários (webkit), alinhada ao tema claro/escuro. */
export function patientQuestionnairesScrollbarSx(theme: Theme) {
  return {
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      background:
        theme.palette.mode === "dark"
          ? theme.palette.grey[800]
          : theme.palette.grey[100],
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[400],
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: theme.palette.grey[500],
    },
  };
}
